import { apiClient } from './api'

export interface PublicSchoolOption {
  id: number
  school_name: string
  school_code?: string
}

/**
 * Public school list (signup / bootstrap). No auth required.
 */
export async function listPublicSchools(): Promise<PublicSchoolOption[]> {
  const response = await apiClient.get('/setup/schools')
  return Array.isArray(response.data) ? response.data : []
}
